const initEripPayment = (agrID, cb, err_cb) => {
  return  (dispatch, getState, { api }) => {    
     return api({
      method: 'POST',
      url: '/apiv2/cabinet/action/agr/eripPayment',
      data: {agrID : agrID}
    }).then(
     ({data}) => { cb && cb(data) },
     ({response})=> {err_cb && err_cb(response.data)})
  }
}

const getMaxInvoiceSum = (agrID, cb, err_cb) => {
  return  (dispatch, getState, { api }) => {    
     return api({
      method: 'POST',
      url: '/apiv2/cabinet/view/BSP/Invoice/CalcValue',
      data: {agrID : agrID}
    }).then(
     ({data}) => {cb && cb(data)},
     ({response})=> { err_cb && err_cb(response.data)})
  }
}

const getInvoicePdf = (agrID, valueWVAT, cb, err_cb) => {
  return (dispatch, getState, { api }) => {
    api.post('/apiv2/cabinet/download/BSP/Invoice',{agrID : agrID, valueWVAT: valueWVAT}, {
      responseType: "blob",
    }).then((response) => {cb && cb(response)})
   };
}

const notificationList = (cb, err_cb) => {
  return  (dispatch, getState, { api }) => {    
     return api({
      method: 'POST',
      url: '/apiv2/cabinet/view/BSP/UNP/Notifications',
      data: {}    
    }).then(
     ({data}) => { cb && cb(data)},
     ({response})=> { err_cb && err_cb(response.data)})
  }
}

const personalInformationList = (cb, err_cb) => {
  return  (dispatch, getState, { api }) => {    
     return api({
      method: 'POST',
      url: '/apiv2/cabinet/view/BSP/UNP/PersonalInfo',
      data: {}    
    }).then(
     ({data}) => { cb && cb(data)},
     ({response})=> { err_cb && err_cb(response.data)})
  }
}


export default {
  initEripPayment,
  getMaxInvoiceSum,
  getInvoicePdf,
  notificationList,
  personalInformationList
};
